import { jwtDecode } from "jwt-decode";

function readStoredUser() {
  try {
    const raw = localStorage.getItem("sb_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getManagerAuth() {
  const token = localStorage.getItem("sb_token");
  const storedUser = readStoredUser();

  if (storedUser?.role === "manager" && storedUser?.pageId && token) {
    return { token, user: storedUser, pageId: String(storedUser.pageId) };
  }

  if (!token) return { token: null, user: null, pageId: null };

  try {
    const decoded = jwtDecode(token);
    const pageId = decoded?.pageId ? String(decoded.pageId) : null;
    const role = decoded?.role || null;

    if (role !== "manager" || !pageId) return { token: null, user: null, pageId: null };

    return {
      token,
      user: {
        id: decoded?.id || null,
        email: decoded?.email || null,
        role: "manager",
        pageId,
      },
      pageId,
    };
  } catch {
    return { token: null, user: null, pageId: null };
  }
}